// ** React Imports
import { Fragment, useEffect } from "react"
import { NavLink, useLocation } from "react-router-dom"
import logo from '../../../../../assets/images/logo/SMARTER (Transparent).png'
// ** Icons Imports
import { Disc, X, Circle } from "react-feather"

// ** Config
import themeConfig from "@configs/themeConfig"
// ** Utils
import { getUserData, getdefaultLogoPath } from '../../../../../utility/Utils'
const VerticalMenuHeader = (props) => {
  // ** Props
  const {
    menuCollapsed,
    setMenuCollapsed,
    setMenuVisibility,
    setGroupOpen,
    menuHover
  } = props

  // ** Vars
  const user = getUserData()
  const location = useLocation()
  // ** Reset open group
  useEffect(() => {
    if (!menuHover && menuCollapsed) setGroupOpen([])
  }, [menuHover, menuCollapsed])

  // ** Menu toggler component
  const Toggler = () => {
    if (!menuCollapsed) {
      return (
        <Disc
          size={20}
          data-tour="toggle-icon"
          className="text-primary toggle-icon d-none d-xl-block"
          onClick={() => setMenuCollapsed(true)}
        />
      )
    } else {
      return (
        <Circle
          size={20}
          data-tour="toggle-icon"
          className="text-primary toggle-icon d-none d-xl-block"
          onClick={() => setMenuCollapsed(false)}
        />
      )
    }
  }

  return (
    <Fragment>
      <div className="navbar-header">
        <ul className="nav navbar-nav flex-row">
          <li className="nav-item me-auto">
            {getUserData()?.logo && <img className='mt-1' style={{ objectFit: "contain" }} width={'200'} height={'50'} src={getdefaultLogoPath(getUserData()?.logo)} />}
          </li>
        </ul>
      </div>
      <hr className="m-0" />
    </Fragment>
  )
}

export default VerticalMenuHeader

